import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { usePostAuthorization } from "@sprout/client-components/dist/Post";
import useToggle from "@sprout/hooks/dist/useToggle";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import { useCallback, useMemo } from "react";
import { AssignmentDialog, LabelsDialog } from "@sprout/client-components/dist/Dialog_next";
import { isNotNull } from "sprout-lib";
export default function usePostPageAssignAndLabelAction(item) {
    var ref2, ref1;
    const { rootTopicOrSelf  } = item;
    const [label, openLabel, closeLabel] = useToggle();
    const authorization = usePostAuthorization(item);
    const canLabel = authorization.addLabel && rootTopicOrSelf;
    useActionRegistryGlobalHandler("PAGE_LABEL", useCallback(()=>{
        openLabel();
        return true;
    }, [
        openLabel
    ]), {
        skip: !canLabel,
        // Required in Chrome, prevent the letter `L` from filling the input
        preventDefault: true
    });
    const labels = (rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : (ref2 = rootTopicOrSelf.labels) === null || ref2 === void 0 ? void 0 : ref2.nodes) || [];
    //
    const [assign, openAssign, closeAssign] = useToggle();
    const workspaceMembers = useMemo(()=>{
        var ref;
        return ((rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : (ref = rootTopicOrSelf.members) === null || ref === void 0 ? void 0 : ref.nodes) || []).map((topicMember)=>topicMember.user).filter(isNotNull);
    }, [
        rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : (ref1 = rootTopicOrSelf.members) === null || ref1 === void 0 ? void 0 : ref1.nodes
    ]);
    const canAssign = authorization.assign && workspaceMembers.length > 0;
    useActionRegistryGlobalHandler("PAGE_ASSIGN", useCallback(()=>{
        openAssign();
        return true;
    }, [
        openAssign
    ]), {
        skip: !canAssign,
        // Required in Chrome, prevent the letter `Y` from filling the input
        preventDefault: true
    });
    const selectedItems = useMemo(()=>[
            item
        ], [
        item
    ]);
    return {
        elements: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                canLabel && /*#__PURE__*/ _jsx(LabelsDialog, {
                    open: label,
                    onRequestClose: closeLabel,
                    selectedItems: selectedItems,
                    rootTopicId: rootTopicOrSelf.id,
                    labels: labels
                }),
                canAssign && /*#__PURE__*/ _jsx(AssignmentDialog, {
                    open: assign,
                    onRequestClose: closeAssign,
                    selectedItems: selectedItems,
                    workspaceMembers: workspaceMembers
                })
            ]
        })
    };
};
